import React from "react";
import AppThemed from "./AppThemed.tsx";
import {GlobalAdmobProvider} from "./core/GlobalAdmob.tsx";
import InAppStoreProvider from "./InAppStoreProvider.tsx";
import JWTAuthProvider from "./JWTAuthProvider.tsx";

const AppContainer = () => {
    return (
        <JWTAuthProvider>
            <InAppStoreProvider>
                <GlobalAdmobProvider>
                    <AppThemed />
                </GlobalAdmobProvider>
            </InAppStoreProvider>
        </JWTAuthProvider>
    );
};

export default AppContainer;
